





















































































import { Component, Prop, Vue, Emit, Watch } from 'vue-property-decorator'
import { Expense, expenseStatuses, IExpense, Payee } from '@/services/models'
import { Action, Getter } from 'vuex-class'

import PayeeSelector from '@/components/PayeeSelector.vue'

import { formatters } from '@/helpers/components-utils'

@Component({
  components: {
    PayeeSelector,
  },
})
export default class EditExpenseModal extends Vue {

  @Getter('firestore/payees')
  private payees!: Payee[]

  @Action('firestore/writeExpense')
  private writeExpense!: (expense: Expense) => Promise<Expense>

  private isModalOpen: boolean = false

  private title: string = ''    // Modal's title.

  private localCopy: Expense = new Expense()

  private formatters = formatters

  private get statusOptions(): string[] {
    return expenseStatuses
  }

  private get revenuePayee(): Payee|undefined {
    const found = this.payees.filter((o) => o.code === 'rd')
    if (found.length > 0) {
      return found[0]
    }
    return undefined
  }

  public async _commit(value: Expense, buttonEvent: any) {
    // Validate
    console.log('Committed!!', buttonEvent)

    // Invoke API
    await this.writeExpense(value)

    // Really push to event handler
    this.commit(value)
  }

  @Emit()
  public commit(value: Expense) {
    // emit!
  }

  // PUBLIC Interface

  public edit(data: IExpense) {
    this.show()
    this.title = `Edit Expense: ${data.id}`
    throw new Error('Implementation is reqired.')
  }

  public create() {
    this.show()
    this.isModalOpen = true
    this.title = 'Create new Expense'
    this.localCopy = new Expense()
  }

  private show() {
    (this.$refs.modalRef as any).show()
  }
}
